module.exports = __webpack_public_path__ + "img/電気回路_5_4_1.b5aeaba7.png";